import { Component, AfterViewInit } from '@angular/core';
import { RouterService } from '../../../services/routerService'
import { HttpService } from '../../../services/httpService'
import { ContextService } from '../../../services/contextService'
import { ConstantsService } from '../../../services/constantsService';
import { TranslateService } from '@ngx-translate/core';
import { AdmissionModel } from '../../../models/admissionnModel'
import * as moment from "moment";
import { BasicDetailModel, ContactDetailsModel, ClassDetailsModel, SchoolingDetailsModel, GuardianDetailsModel } from '../../../models/admissionnModel'
import * as _ from "lodash";

@Component({
  selector: 'admin-page',
  templateUrl: './admission-page.html',
  styleUrls: ['./admission-page.scss']
})

export class AdmissionPageComponent implements AfterViewInit {
  admissionModel: AdmissionModel;
  basicForm: BasicDetailModel;
  contactForm: ContactDetailsModel;
  classForm: ClassDetailsModel;
  schoolForm: SchoolingDetailsModel;
  guardinasForm: GuardianDetailsModel;
  isSwitch: Boolean;
  branch_List: Array<any> = [];
  departmentList: Array<any> = [];
  academicYearOptions: Array<any> = [];
  classroomList: Array<any> = [];
  admiitedClassroomList: Array<any> = [];
  genderOptions: Array<any> = [];
  addGuardians: Boolean = false;
  disableGuardian: Boolean = false;
  switchtoInputText: Boolean = false;
  school_id: any
  appSpinner: any
  admission_type_list = []
  higher_education: Boolean = false
  constructor(private routerService: RouterService, private contextService: ContextService, private httpService: HttpService, private translateService: TranslateService) {
    this.basicForm = new BasicDetailModel();
    this.contactForm = new ContactDetailsModel();
    this.classForm = new ClassDetailsModel();
    this.schoolForm = new SchoolingDetailsModel();
    this.guardinasForm = new GuardianDetailsModel();
    this.appSpinner = this.contextService.getSpinnerContext()
    this.translateService.get('options.academicYears').subscribe(
      res => {
        this.academicYearOptions = res;
      }
    )
    this.translateService.get('options.gender').subscribe(
      res => {
        this.genderOptions = res;
      });
    this.admissionModel = new AdmissionModel();
    this.admissionModel.fatherDetails.guardian_name.valueChangeListener().subscribe(values => {
      if (values.oldvalue !== values.newValue) {
        this.clearMotherDetailErrors()
      }
    })
    this.admissionModel.fatherDetails.qualification.valueChangeListener().subscribe(values => {
      if (values.oldvalue !== values.newValue) {
        this.clearMotherDetailErrors()
      }
    })
    this.admissionModel.fatherDetails.phone_number.valueChangeListener().subscribe(values => {
      if (values.oldvalue !== values.newValue) {
        this.clearMotherDetailErrors()
      }
    })
    this.admissionModel.motherDetails.guardian_name.valueChangeListener().subscribe(values => {
      if (values.oldvalue !== values.newValue) {
        this.clearFatherDetailErrors()
      }
    })

    this.admissionModel.motherDetails.qualification.valueChangeListener().subscribe(values => {
      if (values.oldvalue !== values.newValue) {
        this.clearFatherDetailErrors()
      }
    })
    this.admissionModel.motherDetails.phone_number.valueChangeListener().subscribe(values => {
      if (values.oldvalue !== values.newValue) {
        this.clearFatherDetailErrors()
      }
    })
    this.admissionModel.department_id.valueChangeListener().subscribe(values => {
      if (values.oldvalue !== values.newValue) {
        this.admissionModel.academic_year.value = ""
        this.admissionModel.current_class.value = ""
      }

      // this.admissionModel.academic_year.value = "2020-2021"
      // this.admissionModel.academic_year.disable()
      // this.admissionModel.academic_year.valueChanged()
    })
    this.admissionModel.branch_code.valueChangeListener().subscribe(values => {
      if (values.oldvalue !== values.newValue) {
        this.admission_type_list = []
        this.admissionModel.admission_type.value = ""
        this.admissionModel.department_id.value = ""
        this.loadDepartments()
        this.loadAdmissionTypes()
      }
    })
    this.admissionModel.academic_year.valueChangeListener().subscribe(values => {
      if (values.oldvalue !== values.newValue) {
        this.admissionModel.current_class.value = ""
        this.loadClassrooms()
      }
    })
    this.admissionModel.current_class.valueChangeListener().subscribe(values => {
      if (values.oldvalue !== values.newValue) {
        this.loadAdmittedClass()
      }
    })
    this.admissionModel.previous_school_class.valueChangeListener().subscribe(values => {
      if (values.oldvalue !== values.newValue) {
        if (values.newValue === "NA") {
          this.admissionModel.previous_school_board.value = "NA"
          this.admissionModel.previous_school_board.valueChanged()
          this.admissionModel.previous_school.value = "NA"
          this.admissionModel.previous_school.valueChanged()
        } else {
          this.admissionModel.previous_school_board.reset()
          this.admissionModel.previous_school.reset()
        }
      }
    })
    this.init()
  }

  ngAfterViewInit() {
    this.loadInstitutions()
  }

  init() {
    this.reset()
    var today = moment().toDate()
    this.admissionModel.admission_date.value = moment(today).format(ConstantsService.DATE_FORMAT)
    this.addGuardians = this.admissionModel.addGuardians.value = false
    this.disableGuardian = false
  }

  loadAdmissionTypes(){
    if(this.admissionModel.branch_code.value === 'SCPUC19'){
      this.admission_type_list = [
        {"display": "Day College", "value": "DAYCOLLEGE"}
      ]
    }else{
      this.admission_type_list = [
        { "display": "Day School", "value": "DAYSCHOOL" },
        { "display": "Day School with Lunch", "value": "DAYSCHOOLWITHLUNCH" },
        { "display": "Day Boarding", "value": "DAYBOARDING" },
        { "display": "Boarding", "value": "BOARDING" }
      ]
    }

    if(this.admission_type_list.length == 1){
      this.admissionModel.admission_type.value = this.admission_type_list[0].value
    }
  }

  clearMotherDetailErrors() {
    this.admissionModel.motherDetails.guardian_name.clearError();
    this.admissionModel.motherDetails.qualification.clearError();
    this.admissionModel.motherDetails.phone_number.clearError();
    // this.disableAddGuardian()

  }

  clearFatherDetailErrors() {
    this.admissionModel.fatherDetails.guardian_name.clearError();
    this.admissionModel.fatherDetails.qualification.clearError();
    this.admissionModel.fatherDetails.phone_number.clearError();
    // this.disableAddGuardian()
  }

  disableAddGuardian() {
    if (this.admissionModel.fatherDetails.guardian_name.isValid() || this.admissionModel.motherDetails.phone_number.isValid()) {
      this.disableGuardian = true
    } else {
      this.disableGuardian = false
    }
  }
  loadClassrooms() {
    this.appSpinner.show("Loading....")
    var formData = {
      "school_code": this.school_id,
      "branch_code": this.admissionModel.branch_code.value, "department_code": this.admissionModel.department_id.value,
      "academic_year": this.admissionModel.academic_year.value
    }
    this.classroomList = [];
    this.admiitedClassroomList = [];
    this.httpService.get('schools/list_classrooms', formData).subscribe(res => {
      if(res.length != 0){
        for (var i = 0; i < res.length; i++) {
          var newClassroom = true;
          for (var j = 0; j < this.classroomList.length; j++) {
            if (this.classroomList[j].value == res[i].level_code) {
              newClassroom = false;
              break;
            }
          }

          if (newClassroom) {
            this.classroomList.push({
              "value": res[i].level_code,
              "display": res[i].level,
              "level_id": res[i].level_id,
            })
          }
        }
        this.admiitedClassroomList = _.cloneDeep(this.classroomList)
        this.admiitedClassroomList.push({
          "value": 'NA',
          "display": "None",
          "level_id": "",
        })
      }else{
        this.contextService.getAlertContext().showError(`Admissions are not started for the selected academic year (${this.admissionModel.academic_year.value}). Please select the right one.`);
      }
      this.appSpinner.hide()
    })
  }
  loadAdmittedClass() {
    var classLevelId: any
    for (var i = 0; i < this.classroomList.length; i++) {
      if (this.classroomList[i].value === this.admissionModel.current_class.value) {
        classLevelId = Number(this.classroomList[i].level_id)
      }
    }
    if (classLevelId > 0) {
      for (var j = 0; j < this.classroomList.length; j++) {
        if (Number(this.classroomList[j].level_id) === (classLevelId - 1)) {
          this.admissionModel.previous_school_class.value = this.classroomList[j].display
          this.admissionModel.previous_school_class.valueChanged();
          // this.admissionModel.previous_school_class.disable();
        }
      }
    } else {
      this.admissionModel.previous_school_class.reset()
    }

    if(this.higher_education){
      this.admissionModel.previous_school_class.reset()
    }
  }

  loadDepartments() {
    this.departmentList = []
    for (var j = 0; j < this.branch_List.length; j++) {
      if (this.branch_List[j].value === this.admissionModel.branch_code.value) {
        this.higher_education = this.branch_List[j].higher_education
        this.school_id = this.branch_List[j].school_id
      }
    }
    var formData = { "school_code": this.school_id, "branch_code": this.admissionModel.branch_code.value }
    this.httpService.get('schools/list_departments', formData).subscribe(res => {
      for (var i = 0; i < res.length; i++) {
        this.departmentList.push({ "value": res[i].department_code, "display": res[i].department_name })
      }
      if (this.departmentList.length > 0 && this.departmentList.length == 1) {
        this.admissionModel.department_id.value = this.departmentList[0].value
        this.admissionModel.department_id.valueChanged()
        this.admissionModel.department_id.disable()
      } else {
        this.admissionModel.department_id.enable()
      }
    })
  }

  loadInstitutions() {
    this.branch_List = []
    var formData = {}
    this.appSpinner.show("Loading....")
    this.httpService.get('schools/list_instutions', formData).subscribe(res => {
      // console.log(res)
      for (var i = 0; i < res.length; i++) {
        this.branch_List.push({ "value": res[i].branch_code, "display": res[i].branch_name, school_id: res[i].school_id, higher_education: res[i].higher_degree_offered})
      }
      this.appSpinner.hide();
    })
  }

  closeCard() {
    this.admissionModel.addGuardians.value = false
    this.admissionModel.addGuardians.valueChanged();
    this.addGuardians = this.admissionModel.addGuardians.value
    this.admissionModel.fatherDetails.enable()
    this.admissionModel.motherDetails.enable()
  }

  addGuardian() {
    this.admissionModel.addGuardians.value = true
    this.admissionModel.addGuardians.valueChanged();
    this.addGuardians = this.admissionModel.addGuardians.value
    this.admissionModel.gaurdiansDetails.reset()
    this.clearFatherDetailErrors();
    this.clearMotherDetailErrors();
  }

  apply() {
    if (this.admissionModel.validate() && this.admissionModel.validates()) {
      var gaurdians = this.modifyDataForm()
      var formData = this.getFormData(gaurdians)
      formData["school_code"] = this.school_id
      // console.log(formData)
      var appSpinner = this.contextService.getSpinnerContext();
      var that = this
      this.httpService.post("admissions/apply", formData).subscribe(
        res => {
          appSpinner.hide();
          this.contextService.getAlertContext().showSuccess("Application Successfully Submitted.", function (value) {
            if (value) {
              that.openLanding();
            }
          });
        },
        err => {
          appSpinner.hide();
          if (err.errorCode == 500) {
            err.errorText = "Please Try Again";
          }
          this.contextService.getAlertContext().showError(err.errorText);
        }
      );
    }
  }

  modifyDataForm() {
    var guardianForm = [];
    var finalData = this.getExistingData()
    var that = this
    _.forOwn(finalData, function (value, Key) {
      if (typeof value == 'object') {
        Object.keys(finalData[Key]).forEach(objKey => {
          if (typeof finalData[Key][objKey] == 'undefined') {
            finalData[Key][objKey] = ""
          }
        })
        finalData[Key]['relation'] = Key
        guardianForm.push(finalData[Key])
      } else if (typeof finalData[Key] == 'undefined') {
        finalData[Key] = ""
      } else {
        if (typeof that.basicForm[Key] !== "undefined") {
          that.basicForm[Key].value = value;
          that.basicForm[Key].valueChanged();
        }

        if (typeof that.schoolForm[Key] !== "undefined") {
          if (Key === "is_physically_challenged" || Key === "is_rte_student" || Key === "is_scst") {
            that.schoolForm[Key].value = (value === "true" || value === "t");
          } else {
            that.schoolForm[Key].value = value;
            if (Key === "academic_year") {
              that.schoolForm["admitted_year"].value = value;
              that.schoolForm["admitted_year"].valueChanged();
            }
          }
          that.schoolForm[Key].valueChanged();
        }

        if (typeof that.contactForm[Key] !== "undefined") {
          if (Key === "same_address") {
            that.contactForm[Key].value = (value === "true" || value === "t");
          } else {
            that.contactForm[Key].value = value;
          }
          that.contactForm[Key].valueChanged();
        }

        if (typeof that.classForm[Key] !== "undefined") {
          if (Key == "current_class") {
            for (var i = 0; i < that.classroomList.length; i++) {
              if (that.classroomList[i].value === value) {
                that.schoolForm['admitted_class'].value = that.classroomList[i].display
                that.schoolForm['admitted_class'].valueChanged();
              }
            }
          }
          that.classForm[Key].value = value;
          that.classForm[Key].valueChanged();
        }

      }
    })
    return guardianForm
  }

  getExistingData() {
    var father = false
    var mother = false
    var finalData = this.admissionModel.getData();
    if (this.admissionModel.fatherDetails.guardian_name.isValid() && this.admissionModel.fatherDetails.phone_number.isValid() && this.admissionModel.fatherDetails.qualification.isValid() && !father) {
      father = true
      var fatherData = this.admissionModel.fatherDetails.getData();
      finalData["Father"] = fatherData
      this.addmotherData(finalData, mother);
    }
    if (this.admissionModel.motherDetails.guardian_name.isValid() && this.admissionModel.motherDetails.phone_number.isValid() && this.admissionModel.motherDetails.qualification.isValid() && !mother) {
      mother = true
      var motherData = this.admissionModel.motherDetails.getData();
      finalData["Mother"] = motherData
      this.addfatherData(finalData, father);
    }
    if (this.admissionModel.gaurdiansDetails.guardian_name.isValid() && this.admissionModel.gaurdiansDetails.phone_number.isValid() && this.admissionModel.gaurdiansDetails.qualification.isValid()) {
      var gaurdianData = this.admissionModel.gaurdiansDetails.getData();
      finalData["Legal Guardian"] = gaurdianData
      this.addfatherData(finalData, father);
      this.addmotherData(finalData, mother);
    }
    // console.log(finalData)
    return finalData
  }

  addmotherData(finalData, mother) {
    if (this.admissionModel.motherDetails.guardian_name.isValid() && !mother) {
      mother = true
      var motherData = this.admissionModel.motherDetails.getData();
      finalData["Mother"] = motherData
    }
    return finalData
  }

  addfatherData(finalData, father) {
    if (this.admissionModel.fatherDetails.guardian_name.isValid() && !father) {
      father = true
      var fatherData = this.admissionModel.fatherDetails.getData();
      finalData["Father"] = fatherData
    }
    return finalData
  }
  getFormData(guardianForm) {
    var higher_education = false
    var basicForm = this.basicForm.getData();
    var contactForm = this.contactForm.getData();
    var schoolingForm = this.schoolForm.getData();
    var classForm = this.classForm.getData();
    var entrance_exam = [];
    var qualifying_exam = [];
    var studentForm = Object.assign(basicForm, contactForm, schoolingForm, classForm);
    studentForm["department_code"] = studentForm["department_id"];
    var formData = {
      "higher_degree_offered": higher_education,
      "student": studentForm,
      "guardians": guardianForm,
      "qualifying_exam": qualifying_exam,
      "entrance_exam": entrance_exam

    }
    _.forOwn(formData, function (value, Key) {
      if (typeof value == 'object') {
        Object.keys(formData[Key]).forEach(objKey => {
          if (typeof formData[Key][objKey] === 'undefined') {
            formData[Key][objKey] = ""
          }
        })
      } else if (typeof formData[Key] == 'undefined') {
        formData[Key] = ""
      }
    })
    return formData;
  }

  openLanding() {
    this.routerService.openLandingPage();
  }

  reset() {
    this.schoolForm.reset();
    this.basicForm.reset();
    this.contactForm.reset();
    this.guardinasForm.reset();
    this.classForm.reset();
    this.admissionModel.reset()
  }
}
